module.exports = __webpack_public_path__ + "static/media/img-cta.1feefd8c.png";